export default __webpack_public_path__ + "static/media/Badge_ENG.9cf51970.svg";